import api from "../../api";
import { TipoBanca } from "../../model/banca/Banca";


export class TipoBancaViewModel{
    static async getTipoBanca(bancaId: string): Promise<TipoBanca>{
        try{
            const tipoBanca: TipoBanca = (await api.get(`/bancas/${bancaId}/tipo`)).data;
            return tipoBanca;
        }
        catch(error){
            throw error;
        }
    }

    static async getTiposBanca(forceRefresh: boolean = false): Promise<TipoBanca[]> {
        if (!forceRefresh) {
            const storedTiposBanca = sessionStorage.getItem('tipos_banca');
            if (storedTiposBanca) {
                try {
                    return JSON.parse(storedTiposBanca);
                } catch (error) {
                    sessionStorage.removeItem('tipos_banca');
                }
            }
        }
    
        try {
            const response = await api.get('/tipoBanca', {
                headers: { 'Cache-Control': 'no-cache' }
            });
            const tiposBanca = response.data;
            sessionStorage.setItem('tipos_banca', JSON.stringify(tiposBanca));
            return tiposBanca;
        } catch (error) {
            sessionStorage.removeItem('tipos_banca');
            throw error;
        }
    }

    static clearCache(): void {
        sessionStorage.removeItem('tipos_banca');
    }
}